import { render } from "./SpeakerCard.vue?vue&type=template&id=fc4ab7aa&scoped=true"
import script from "./SpeakerCard.vue?vue&type=script&lang=js"
export * from "./SpeakerCard.vue?vue&type=script&lang=js"

import "./SpeakerCard.vue?vue&type=style&index=0&id=fc4ab7aa&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc4ab7aa"]])

export default __exports__